$( document ).ready(function() {

  // FADE IN/OUT
  /*window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function() {
    setTimeout(function(){
    	$("body").removeClass("fade-out");
    }, 250);
  }, false);
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);*/

  Marquee3k.init({
      selector: 'marquee3k',
  });
  
  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            setTimeout(function(){
              l.src = l.dataset.src;
            }, 500);
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }

  // ARTICLE DESKTOP
  var ww = $(window).width()
  if(ww > 820){
    $( ".template-article .image-article" ).each(function( i ) {
      i = i + 1
      i = "00" + parseInt(i)
      i = i.slice(-3);
      $(this).append("<span class='counter-images mono'>" + i + "</span>")
      $(this).appendTo("#left-column");
    });
    $( ".template-article .right-article" ).each(function( i ) {
      $(this).appendTo("#right-column");
    });
  }

  // SHOW MENU
  $("#products-header").click(function() {
    event.preventDefault();
    $("#products-menu").toggleClass("show-product-in-mobile");
  });
  $( "#products-header, #products-menu" ).hover(
    function() {
      $("#products-menu-container").show();
    }, function() {
      $("#products-menu-container").hide();
    }
  );

  // REMOVE VARIANT FROM MINICART
  $( ".change-title" ).each(function( i ) {
    var getText = $(this).text();
    getText = getText.split('-')[0]
    $(this).text(getText);
  });
  
  // MENU
  $( "#menu-mobile" ).click(function() {
    $('#products-menu-container').toggleClass('show-mobile');
    $(this).children("span").toggle();
    $('html, body').animate({
      scrollTop: 0
    }, 300);
    setTimeout(function(){
      $("body").toggleClass("noscroll");
    }, 300);
  });

  // QTY PRODUCT
  $( ".minus-quan" ).click(function() {
    var getValue = $("#qty").attr("value")
    getValue = parseFloat(getValue) - 1;
    if (getValue > 0) {
      $("#qty").val(getValue);
      $("#qty").attr("value", getValue);
    }
  });
  $( ".plus-quan" ).click(function() {
    var getValue = $("#qty").attr("value")
    getValue = parseFloat(getValue) + 1;
    $("#qty").val(getValue);
    $("#qty").attr("value", getValue);
  });
  
  // TOGGLE MINICART
  $( "#cart-trigger, #cart-trigger-mobile" ).click(function() {
    $( "#mini-cart" ).toggleClass("active");
    $( "#fakexit" ).toggle();
  });
  $( "#burger-cart" ).click(function() {
    event.preventDefault();
    //$("#fakexit").toggle();
    $( "#mini-cart" ).removeClass("active");
    $("#cart-trigger").removeClass("active");
    $("#burger-cart").removeClass("active");
    $("#header-bar").removeClass("active-home");
  });
  $( "#mini-cart-close, #fakexit" ).click(function() {
    $("#fakexit").hide();
    $( "#mini-cart" ).removeClass("active");
  });
  
  // ADD/REMOVE ITEM
  setTimeout(function(){
    $('.cart-product-quantity').each(function() {
      var quantity = $(this).find('input').val(),
          quentityDiv = $(this).find('.quantity-wrap');
      quentityDiv.text(quantity);
      $(this).on('click', '.plus', function(e) {
        incrementValue(e);
      });
      $(this).on('click', '.minus', function(e) {
        decrementValue(e);
      });
    });
  }, 20);
  // ADD PRODUCT
  function incrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);

    if (!isNaN(currentVal)) {
      parent.find('input[name="updates[]"]').val(currentVal + 1);
      parent.find(".quantity-wrap").text(currentVal + 1);
    } else {
      parent.find('input[name="updates[]"]').val(0);
      parent.find(".quantity-wrap").text(0);
    }
  }
  // REMOVE PRODUCT
  function decrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    
    if (!isNaN(currentVal) && currentVal > 0) {
      parent.find('input[name="updates[]"]').val(currentVal - 1);
      parent.find(".quantity-wrap").text(currentVal - 1);
    } else {
      parent.find('input[name="updates[]"]').val(0);
      parent.find(".quantity-wrap").text(0);
    }
  }
  // UPDATE CART FUNCTION
  $(document).on('click', '.quantity-button', function(event) {
    event.preventDefault();
    setTimeout(function(){
      $("#update-cart").show();
    }, 10);
  });

  // LEGAL TRIGGERS
  $( ".legal-trigger" ).click(function() {
    var getHash = $(this).attr("data-ide")
    var getTrigger = $(this).attr("data-ide")
    getTrigger = "#" + getTrigger + "-blocks-content"
    var getTitle = $(this).attr("data-ide")
    getTitle = "#" + getTitle + "-title"
    console.log(getTitle)
    $(".legal-block, .legal-title").hide();
    $(getTrigger).show();
    $(getTitle).show();
    $( ".legal-trigger" ).removeClass("active");
    $(this).addClass("active");
    history.replaceState("", document.title, window.location.pathname);
    window.location.hash = getHash;
  });

  // MINI CART INDEXES
  $('.item-index').each(function(i, select){
    var val = $(this).text()
    val = "0" + parseInt(val)
    val = val.slice(-2);
    $(this).text(val)
  });

  // SELECT TO RADIO BUTTON
  $('.product-select-homepage').each(function(i, select){
      var $select = $(select);
      $select.find('option').each(function(j, option){
          var $option = $(option);
          // Create a radio
          var $radio = $('<input type="radio" />');
          // Set name and value:
          $radio.attr('name', $select.attr('name')).attr('value', $option.val()).attr('class', 'variant-input');
          // Set checked if the option was selected
          if ($option.attr('selected')) $radio.attr('checked', 'checked').addClass('checked-variant');
          // Set sold-out class if sold-out class was there
          if ( $($option).is( ".sold-out-variant" ) ) {
            $radio.addClass('sold-out-variant').prop( "disabled", true );
          }
          // Insert radio before select box
          $select.before($radio);
          // Insert a label
          $select.before(
            $("<label />").attr('class', 'variant-input-label').attr('for', $select.attr('name')).text($option.text())
          );
      });
      $select.remove();
  });

  // REMOVE SOLD OUT
  setTimeout(function(){
    $( ".variant-input-label" ).each(function( index ) {
      var text = $(this).text();
      $(this).text(text.replace('-sold-out', ''));         
    });
  }, 300);

  // SELECT SIZE
  setTimeout(function(){
    $( ".variant-input" ).each(function( index ) {
      if ( $(this).is( ".checked-variant" ) ) {
        $(this).next().addClass("selected-size-label");
      }
      if ( $(this).is( ".sold-out-variant" ) ) {
        $(this).next().addClass("sold-out-variant-label-last");
      }
    });
    $( ".variant-input-label" ).click(function() {
      $(this).prev().prop( "checked", true );
      $(this).parent().children( ".variant-input-label" ).removeClass("selected-size-label");
      $(this).parent().parent().children(".product-add").children(".addtoca").removeClass("unavailable");
      $(this).addClass("selected-size-label");
    });
  }, 200);

  // SWIPER SECOND SKIN
  const swiper = new Swiper('.swiper-second-skin', {
    direction: 'horizontal',
    loop: true,
    speed: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoHeight: true,
    spaceBetween: 30
  });

  // VIDEO SECOND SKIN
  $('.video-second-skin').click(function(){
      var $this = $(this);
      $this.toggleClass('active');
      if($this.hasClass('active')){
          $this.children("video").get(0).play();
      } else {
          $this.children("video").get(0).pause();
      }
  });
  
});